export const loadJsonFromElement = (alias) => {
    const el = document.getElementById(alias);
    if (el) {
        return JSON.parse(el.innerText);
    }
};